module.exports = __webpack_public_path__ + "static/media/answer3.5afd03c5.png";